// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
  AR_MOBILE: '[data-fragment="ARChoose.armobile"]',
  OTHER: '[data-fragment="ARChoose.other"]',
};

export default class ARChoose extends WebComponent {
  constructor(props) {
    super(props);

    this.state = {
      device: 'other',
    };
  }

  getDeviceLink = () => {
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/android/i.test(userAgent)) {
      return 'intent://arvr.google.com/scene-viewer/1.0?file=https://www.cafedock.com/img/virtual-reality/Dallmayr_CafeDock.glb#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=https://www.cafedock.com/?openPopup=model;end;';
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'https://www.cafedock.com/img/virtual-reality/Dallmayr_CafeDock.usdz';
    }
    return '#';
  }

  didMount() {
    this.linkAr = this.element.querySelector(fragments.AR_MOBILE).querySelector('a');
    this.linkOther = this.element.querySelector(fragments.OTHER).querySelector('a');
    this.setState({ deviceLink: this.getDeviceLink() });
  }

  update() {
    const { deviceLink } = this.state;
    if (deviceLink == '#') {
      this.linkOther.classList.remove('d-none');
    } else {
      this.linkAr.classList.remove('d-none');
      this.linkAr.setAttribute('href', deviceLink);
    }
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ARChoose.js